<template>
    <a-card size="small" title="关联系统">
        <div slot="extra" style="width:200px;float:right;">
            <v-gobackbutton>返回</v-gobackbutton>
            <a-button type="primary" class="fr mr20" slot="extra" @click="handleNew">新建</a-button>

        </div>
        <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="getAppSumData">
            <a-form-item label="选择环境">
                    <a-icon type="menu-unfold-outlined" style="color: #0070cc" />

                <a-button type="normal" @click="handleEnvClick">
                    {{kadesc}}
                    <a-icon type="down" style="color: #0070cc" />
                </a-button>

                <kaenvselecter ref="envSelecter" @onModalHide="handleEnvSelect"></kaenvselecter>
            </a-form-item>
            <a-form-item label="关键字">
                <a-input v-model="keyword" placeholder="请输入关键字"></a-input>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="getAppSumData">查询</a-button>
            </a-form-item>

             <a-form-item>
                <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                </a-button>
            </a-form-item>
        </a-form>
        <!-- 系统列表 -->
        <a-table :columns="columns" :data-source="tableData" class="mt20" :scroll="{ x: clientWidth}"
            :pagination="false" :loading="tloading" rowKey="syscode">

            <template slot="operation" slot-scope="text, record">
                <div class="editable-row-operations">
                    <a-button type="link" @click="handleView(record)">详情</a-button> 
                    <a-button type="link" @click="handleEdit(record)">编辑</a-button> 
                    <a-button type="link" @click="handleBuild(record)">系统构建</a-button> 
                    <a-button type="link" @click="handleDeploy(record)">配置下发</a-button> 


                    <a-popconfirm  title="确认解除关联?" @confirm="() => onDelete(record)">
                                <a  href="javascript:;">解除关联</a>
                    </a-popconfirm>
                </div>
            </template>
            
        </a-table>
        <a-pagination class="my_pagenation" v-model="pagination.page" :total="pagination.total" @change="handlePageChange"
                      show-less-items show-quick-jumper/>

        <a-modal v-model="visible" title="系统构建">
            <p>上次状态：{{last_statue}}</p>
            <a-spin :tip="modal_title" :spining="modalLoading">
                <div style="height:100px;width:100%;">
                    
                </div>
            </a-spin>
        </a-modal>
    </a-card>
</template>
<script>
import kaenvselecter from '../com/kaenvselecter.vue'
let pagination={
    total:0,
    pageSize:0,
    current:1,
}

const columns = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagination;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        }
    },
    { 
        title: '系统编码', 
        dataIndex: 'syscode',
        align:'center',
        width:100, 
    },
    { 
        title: '代码分支', 
        dataIndex: 'branch',
        align:'center',
        ellipsis:true,
        width:100, 
    },
    // { 
    //     title: '额外参数', 
    //     dataIndex: 'paramjson',
    //     align:'center',
    //     ellipsis:true,
    //     width:100, 
    // },

    { 
        title: 'cpu数量', 
        dataIndex: 'cpu',
        align:'center',
        width:100, 
    },
    { 
        title: '内存大小', 
        dataIndex: 'memory',
        align:'center',
        width:100, 
    },
    { 
        title: '副本数量', 
        dataIndex: 'replics',
        align:'center',
        width:100, 
    },
    { 
        title: '分类', 
        dataIndex: 'tag',
        align:'center',
        ellipsis:true,
        width:100, 
    },
    // { 
    //     title: 'Java启动参数', 
    //     dataIndex: 'javaopts',
    //     align:'center',
    //     ellipsis:true,
    //     width:200, 
    // },
    
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 200,
        // fixed:'right',
        scopedSlots: { customRender: 'operation' },
    }

];
export default {
    components:{
        kaenvselecter
    },
    data() {
        return {
            form: this.$form.createForm(this),
            columns,
            tableData:[],
            tloading:false,
            clientWidth:800,
            pagination,
            kaenv:'',
            kadesc:'',
            keyword:'',
            queryHandller:null,
            tempParams:{},
            visible:false,
            modalLoading:false,
            modal_status:'sucess',
            modal_title:'',
            last_statue:''

        };
    },
    methods: {
        //构建系统
        // handleBuild(record){
        //     let that = this;
        //     that.visible = true;
        //     that.modalLoading = true;
        //     that.tempParams = {
        //         kaenv:record.kaenv,
        //         syscode:record.syscode
        //     };
        //     that.queryStatus(1);
        //     this.$store.dispatch({
        //         type: "kamanager/buildJob",
        //         params: that.tempParams
        //     }).then((res) => {
        //         if(res.data.success == 1){
        //             that.startQuery();
        //         }
        //     });
        // },
        handleBuild(record){
            let that = this;
            that.tempParams = {
                kaenv:record.kaenv,
                syscode:record.syscode
            };
            this.$store.dispatch({
                type: "kamanager/queryJobUrl",
                params: that.tempParams
            }).then((res) => {
                if(res.data.success == 1){
                    window.open(res.data.data)
                }
            });
        },
        //配置下发
        handleDeploy(record){
            let that = this;
            that.tempParams = {
                kaenv:record.kaenv,
                syscode:record.syscode
            };
            this.$store.dispatch({
                type: "kamanager/syncJenkinsOne",
                params: that.tempParams
            }).then(() => {
                this.getAppSumData();
            });
        },
 
        startQuery(){
            let that = this;
            that.queryHandller = setInterval(function () {
                that.queryStatus();
            }, 3000);
        },
        
        //轮询任务状态
        queryStatus(flag) {
            let that = this;
            let queryType =  'kamanager/queryJobStatus';
            let result_msg = {
                'FAILURE':'构建失败',
                'UNSTABLE':'不稳定',
                'REBUILDING':'重建中',
                'BUILDING':'构建中',
                'ABORTED':'已中止',
                'SUCCESS':'构建成功',
                'UNKNOWN':'未知状态',
                'NOT_BUILT':'未构建',
                'CANCELLED':'已取消',
            };
            that.$store.dispatch({
                type: queryType,
                params: that.tempParams
            }).then((res) => {
                if(res.data.success == 1){
                    let status = res.data.data;
                    if(flag == 1){
                        that.last_statue = result_msg[status];
                        return;
                    }
                    else{
                        that.modal_title = result_msg[status];
                    }
                    // 枚举值    
                    if(status != 'BUILDING'){
                        that.queryEnd();
                    }
                    
                }
            });
        },
        queryEnd(){
            let that = this; 
            clearInterval(that.queryHandller);
            that.queryHandller = null;  
            that.pagination.page = 1;
            that.modalLoading = false;
        },
        //解除关联
        onDelete(record) {
            this.$store.dispatch({
                type: "kamanager/disableRelation",
                params: {
                    kaenv:record.kaenv,
                    syscode:record.syscode
                }
            }).then(() => {
                this.pagination.page = 1;
                this.getAppSumData();
            });
        },
        handleEnvClick(){
            this.$refs.envSelecter.modalState.isShow = true;
        },
        handleEnvSelect(envList){
            if(envList){
                let env =  envList[0];
                this.kaenv = env.kaenv;
                this.kadesc = env.kadesc;
            }
            this.$refs.envSelecter.modalState.isShow = false;
            this.getAppSumData();

        },
        handleView(record){
            this.$router.push({
                path:'detailbindsys',
                query:{
                    kaenv:this.kaenv,
                    syscode:record.syscode,
                    kadesc:this.kadesc,
                }
            })
        },
        handleNew(){
            this.$router.push({
                path:'newbindsys',
                query:{
                    kaenv:this.kaenv,
                    kadesc:this.kadesc,
                }
            })
        },
        handleEdit(record){
            this.$router.push({
                path:'editbindsys',
                query:{
                    kaenv:this.kaenv,
                    syscode:record.syscode,
                    kadesc:this.kadesc,
                }
            })
        },
        handleSearchReset(){
            this.keyword = ''
            this.pagination.page = 1;
            this.getAppSumData()
        },
        handlePageChange(c_p) {
            this.pagination.page = c_p;
            this.getAppSumData();
        },
        getAppSumData(){
            let that = this
            that.tloading = true
            let params = {
                keyword:that.keyword,
                kaenv:that.kaenv,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: 'kamanager/queryRelatedSys',
                params:params
            }).then((res)=>{
                that.tloading = false;
                let result = res.data.data;
                that.tableData = result.list;
                that.pagination.total = result.totalRecords;
                that.pagination.pageSize = result.pageSize;
                that.pagination.page = result.page;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSearch(){
            this.pagination.page = 1;
            this.getAppSumData();
        },
    },
    mounted(){
    }
};
</script>

<style scoped>
.my-input{
        padding: 4px 20px;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    line-height: 1.5;
    background-color: #fff;
    background-image: none;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
}
</style>
